import ReactDOM from 'react-dom/client';
import App from './app/App';

import 'rsuite/dist/rsuite.min.css';
import './css/style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
